import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
const { fontFamily: inter } = loadInter("normal", { weights: ["700","800"], subsets: ["latin"] });

// Portrait LS Variant 1 — Temple bell + like/sub card, bottom-right
const BellSVG: React.FC<{ angle: number }> = ({ angle }) => (
  <svg width="40" height="44" viewBox="0 0 72 80" fill="none">
    <circle cx="36" cy="6" r="5" fill="#B8860B" />
    <path d="M36 6C36 6 14 18 14 44V58H58V44C58 18 36 6 36 6Z" fill="#FFD700" stroke="#B8860B" strokeWidth="2" />
    <ellipse cx="36" cy="58" rx="12" ry="5" fill="#B8860B" />
    <circle cx="36" cy="66" r="6" fill="#8B6914" />
    <ellipse cx="26" cy="28" rx="4" ry="9" fill="rgba(255,255,255,0.3)" transform={`rotate(-15 26 28) rotate(${angle} 36 66)`} />
  </svg>
);

export const ReelLS1: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const bellAngle = interpolate(frame,
    [0, Math.round(fps*0.3), Math.round(fps*0.6), Math.round(fps*0.9), Math.round(fps*1.2), Math.round(fps*1.5)],
    [0, 28, -20, 12, -6, 0], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const slideY = interpolate(frame, [0, Math.round(fps*0.5)], [40,0], { extrapolateRight:"clamp", extrapolateLeft:"clamp", easing: Easing.bezier(0.16,1,0.3,1) });
  const fadeIn  = interpolate(frame, [0, Math.round(fps*0.4)], [0,1], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const fadeOut = interpolate(frame, [Math.round(fps*5), Math.round(fps*6)], [1,0], { extrapolateLeft:"clamp", extrapolateRight:"clamp" });
  const btnOp   = interpolate(frame, [Math.round(fps*0.7), Math.round(fps*1.2)], [0,1], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const likeClicked = frame >= Math.round(fps*1.6);
  const subClicked  = frame >= Math.round(fps*2.3);
  const likeScale = interpolate(frame, [Math.round(fps*1.6), Math.round(fps*1.68), Math.round(fps*1.8)], [1,0.86,1.06], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const subScale  = interpolate(frame, [Math.round(fps*2.3), Math.round(fps*2.38), Math.round(fps*2.5)], [1,0.86,1.06], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  return (
    <AbsoluteFill style={{ overflow:"hidden" }}>
      <div style={{ position:"absolute", inset:0, opacity: fadeIn*fadeOut }}>
        <div style={{ position:"absolute", top:"50%", right:20, transform:`translateY(calc(-50% + ${slideY}px))`, display:"flex", flexDirection:"column", alignItems:"center", gap:0 }}>
          <div style={{ transform:`rotate(${bellAngle}deg)`, transformOrigin:"top center", filter:"drop-shadow(0 6px 14px rgba(0,0,0,0.6))", marginBottom:-6, zIndex:2 }}>
            <BellSVG angle={bellAngle} />
          </div>
          <div style={{ opacity:btnOp, background:"rgba(15,15,15,0.88)", backdropFilter:"blur(10px)", borderRadius:11, padding:"8px 12px", border:"1px solid rgba(255,215,0,0.4)", boxShadow:"0 8px 28px rgba(0,0,0,0.65)", display:"flex", flexDirection:"column", alignItems:"center", gap:6, minWidth:140 }}>
            <span style={{ color:"#FFD700", fontSize:8, fontWeight:700, fontFamily:inter, letterSpacing:1, textTransform:"uppercase" }}>Deva Katha</span>
            <div style={{ display:"flex", gap:6, width:"100%" }}>
              <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:3, background: likeClicked?"#1a73e8":"rgba(255,255,255,0.12)", border:`1px solid ${likeClicked?"#1a73e8":"rgba(255,255,255,0.2)"}`, borderRadius:12, padding:"5px 0", transform:`scale(${likeScale})`, boxShadow: likeClicked?"0 4px 14px rgba(26,115,232,0.5)":"none" }}>
                <span style={{ color:"#fff", fontSize:9, fontWeight:800, fontFamily:inter, whiteSpace:"nowrap" }}>👍 {likeClicked?"Liked!":"Like"}</span>
              </div>
              <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background: subClicked?"#606060":"#FF0000", borderRadius:12, padding:"5px 0", transform:`scale(${subScale})`, boxShadow: subClicked?"none":"0 4px 16px rgba(255,0,0,0.55)" }}>
                <span style={{ color:"#fff", fontSize:9, fontWeight:800, fontFamily:inter, whiteSpace:"nowrap" }}>{subClicked?"Subscribed ✓":"Subscribe"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
